export default __webpack_public_path__ + "static/media/IconPencil.d7525076.svg";